import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toggleUserMfaEnforcement } from '../services/users';
import { userKeys } from './useUsersQuery';
import { handleUserMutationError } from '../services/userErrorHandler';
import type { AdminUser } from '../types/users.types';

interface ToggleMfaEnforcementParams {
    id: string;
    enforce: boolean;
}

export const useToggleMfaEnforcementMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<AdminUser, Error, ToggleMfaEnforcementParams>({
        mutationFn: ({ id, enforce }) => toggleUserMfaEnforcement(id, enforce),
        onSuccess: (_, { id }) => {
            queryClient.invalidateQueries({ queryKey: userKeys.detail(id) });
            queryClient.invalidateQueries({ queryKey: userKeys.lists() });
        },
        onError: (error) => handleUserMutationError(error),
    });
};
